import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { __decorate } from "tslib";
// Docs: https://armour.github.io/vue-typescript-admin-docs/features/components/rich-editor.html#tinymce
import 'tinymce/tinymce';
import 'tinymce/themes/silver'; // Import themes
import 'tinymce/themes/mobile';
import 'tinymce/plugins/advlist'; // Any plugins you want to use has to be imported
import 'tinymce/plugins/anchor';
import 'tinymce/plugins/autolink';
import 'tinymce/plugins/autosave';
import 'tinymce/plugins/code';
import 'tinymce/plugins/codesample';
import 'tinymce/plugins/directionality';
import 'tinymce/plugins/emoticons';
import 'tinymce/plugins/fullscreen';
import 'tinymce/plugins/hr';
import 'tinymce/plugins/image';
import 'tinymce/plugins/imagetools';
import 'tinymce/plugins/insertdatetime';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/plugins/media';
import 'tinymce/plugins/nonbreaking';
import 'tinymce/plugins/noneditable';
import 'tinymce/plugins/pagebreak';
import 'tinymce/plugins/paste';
import 'tinymce/plugins/preview';
import 'tinymce/plugins/print';
import 'tinymce/plugins/save';
import 'tinymce/plugins/searchreplace';
import 'tinymce/plugins/spellchecker';
import 'tinymce/plugins/tabfocus';
import 'tinymce/plugins/table';
import 'tinymce/plugins/template';
import 'tinymce/plugins/textpattern';
import 'tinymce/plugins/visualblocks';
import 'tinymce/plugins/visualchars';
import 'tinymce/plugins/wordcount';
import TinymceEditor from '@tinymce/tinymce-vue'; // TinyMCE vue wrapper
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';
import { SettingsModule } from '@/store/modules/settings';
import EditorImageUpload from './components/EditorImage.vue';
import { plugins, toolbar } from './config';
const defaultId = () => 'vue-tinymce-' + +new Date() + ((Math.random() * 1000).toFixed(0) + '');
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.hasChange = false;
    this.hasInit = false;
    this.fullscreen = false;
    // https://www.tiny.cloud/docs/configure/localization/#language
    // and also see langs files under public/tinymce/langs folder
    this.languageTypeList = {
      en: 'en'
    };
  }
  get language() {
    return this.languageTypeList[AppModule.language];
  }
  get uploadButtonColor() {
    return SettingsModule.theme;
  }
  get tinymceContent() {
    return this.value;
  }
  set tinymceContent(value) {
    this.$emit('input', value);
  }
  get containerWidth() {
    const width = this.width;
    // Test matches `100`, `'100'`
    if (/^[\d]+(\.[\d]+)?$/.test(width.toString())) {
      return `${width}px`;
    }
    return width;
  }
  get initOptions() {
    return {
      selector: `#${this.id}`,
      height: this.height,
      body_class: 'panel-body ',
      object_resizing: false,
      toolbar: this.toolbar.length > 0 ? this.toolbar : toolbar,
      menubar: this.menubar,
      plugins: plugins,
      language: this.language,
      language_url: this.language === 'en' ? '' : `${process.env.BASE_URL}tinymce/langs/${this.language}.js`,
      skin_url: `${process.env.BASE_URL}tinymce/skins/`,
      emoticons_database_url: `${process.env.BASE_URL}tinymce/emojis.min.js`,
      end_container_on_empty_block: true,
      powerpaste_word_import: 'clean',
      code_dialog_height: 450,
      code_dialog_width: 1000,
      advlist_bullet_styles: 'square',
      advlist_number_styles: 'default',
      imagetools_cors_hosts: ['www.tinymce.com', 'codepen.io'],
      default_link_target: '_blank',
      link_title: false,
      nonbreaking_force_tab: true,
      init_instance_callback: editor => {
        if (this.value) {
          editor.setContent(this.value);
        }
        this.hasInit = true;
        editor.on('NodeChange Change KeyUp SetContent', () => {
          this.hasChange = true;
          this.$emit('input', editor.getContent());
        });
      },
      setup: editor => {
        editor.on('FullscreenStateChanged', e => {
          this.fullscreen = e.state;
        });
      }
    };
  }
  onLanguageChange() {
    const tinymceManager = window.tinymce;
    const tinymceInstance = tinymceManager.get(this.id);
    if (this.fullscreen) {
      tinymceInstance.execCommand('mceFullScreen');
    }
    if (tinymceInstance) {
      tinymceInstance.destroy();
    }
    this.$nextTick(() => tinymceManager.init(this.initOptions));
  }
  imageSuccessCBK(arr) {
    const tinymce = window.tinymce.get(this.id);
    arr.forEach(v => {
      tinymce.insertContent(`<img class="wscnph" src="${v.url}" >`);
    });
  }
};
__decorate([Prop({
  required: true
})], default_1.prototype, "value", void 0);
__decorate([Prop({
  default: defaultId
})], default_1.prototype, "id", void 0);
__decorate([Prop({
  default: []
})], default_1.prototype, "toolbar", void 0);
__decorate([Prop({
  default: 'file edit insert view format table'
})], default_1.prototype, "menubar", void 0);
__decorate([Prop({
  default: '360px'
})], default_1.prototype, "height", void 0);
__decorate([Prop({
  default: 'auto'
})], default_1.prototype, "width", void 0);
__decorate([Watch('language')], default_1.prototype, "onLanguageChange", null);
default_1 = __decorate([Component({
  name: 'Tinymce',
  components: {
    EditorImageUpload,
    TinymceEditor
  }
})], default_1);
export default default_1;